import _ from 'lodash';
import axios from 'axios';
import firebase from 'firebase/app';
import  'firebase/auth';

import {getUsernameAndNavTo, createUser} from './user_api_actions';
import {TSOCIAL_LOGIN, TSOCIAL_LOGGED_IN, TSOCIAL_NOT_LOGGED_IN,
  TLOGGING_OUT_USER,  TLOGGED_OUT_USER, TNOT_LOGGED_OUT_USER,
  TRESET_ERR, TFBASE_USER_LOGIN, TFBASE_USER_NOT_LOGGEDIN,
  TFBASE_CREATE_USER, TFBASE_USER_NOT_CREATED} from "./types.js"
import {URANDOM_USER} from './api_const';

//// FIREBASE ACTIONS ////
export async function getCurUserJWT() {
    const {currentUser} = firebase.auth();
    // console.log('currentUser', currentUser)
    // TODO check resp!? not sure how this will fail, if cur user, it can generate jwt token
    // const token = await firebase.auth().currentUser.getIdToken();
    if (currentUser) {
      const token = await currentUser.getIdToken();
      return token
    } else {
      return ''
    }

}

export const sendResetPwEmail = (email) => {
  const auth = firebase.auth();
  return (dispatch) => {
    auth.sendPasswordResetEmail(email)
    .then(alert(
      "Reset Email with instructions has been sent!"
    ))
    .catch( err => alert(err));
  };
};

export const logoutUser = (callback) =>  {
  // NOTE delete line below later, some cases where no callback is passed...
  const cb = callback ? () => callback() : () => console.log('empty');
  return (dispatch) => {
    dispatch({type: TLOGGING_OUT_USER});
    firebase.logout()
      .then( () => {
        dispatch({type: TLOGGED_OUT_USER});
        cb();
      })
      .catch( err => dispatch({
        type: TNOT_LOGGED_OUT_USER,
        errMsg: `cannot logout user: ${err}`
      }));
  };
};

export function resetErrorAfterPrompt() {
  return ({type: TRESET_ERR});
}

export const loginFirebaseUser = (email, password, hist) => {
  return (dispatch) => {
    dispatch({type: TFBASE_USER_LOGIN});
    firebase.login({email, password})
      // will loading set to false handled by getUsername
      .then( resp => {
        resp.user.user.getIdToken()
          .then( resp_token => {
            dispatch({type: TSOCIAL_LOGGED_IN});
            dispatch(getUsernameAndNavTo(resp_token, hist));
          })
          .catch(err => dispatch({
            type: TSOCIAL_NOT_LOGGED_IN,
            errMsg: `cannot get bearer token: ${err}`,
          }));
      })
      .catch( error => {
        let errMsg = error.message;
        if (error.code === "auth/wrong-password") {
          errMsg = 'Invalid Password! Please try again, or reset yout password';
        } else if (error.code === "auth/user-not-found") {
          errMsg = 'Email not registered! To make a new account, click signup :)';
        }
        dispatch({type: TFBASE_USER_NOT_LOGGEDIN, errMsg});
      });
  };
};

export const createNewFirebaseUser = (email, password, fullName, hist) => {
  return (dispatch) => {
    dispatch({type: TFBASE_CREATE_USER});
    firebase.createUser({email, password})
      .then( resp => createNewUserFromToken(dispatch, resp.user, fullName, email, hist) )
      .catch(error => {
        let errMsg = error.message;
        if (error.code === 'auth/email-already-in-use') {
          errMsg = `The email ${email} has already been registered!`;
        } else if (error.code === 'auth/weak-password') {
          errMsg = `Try a new password! ${error.message}`;
        }
        dispatch({type: TFBASE_USER_NOT_CREATED, errMsg});
      });
  };
};

export const loginWithSocial = (provider_name, hist) => {
  let provider = null;
  if (provider_name === 'google') {
    provider = new firebase.auth.GoogleAuthProvider();
  } else if (provider_name === 'facebook') {
    provider = new firebase.auth.FacebookAuthProvider();
  } else if (provider_name === 'twitter') {
    provider = new firebase.auth.TwitterAuthProvider();
  }

  return (dispatch) => {
    dispatch({type: TSOCIAL_LOGIN});
    if (provider === null) {
      dispatch({
        type: TSOCIAL_NOT_LOGGED_IN,
        errMsg: `invalid social media provider: ${provider_name}`,
      });
    } else {
      firebase.auth().signInWithPopup(provider)
        .then(resp => {
          // NOTE if no account exists, make one
          if (resp.additionalUserInfo.isNewUser) {
            createNewUserFromToken(dispatch, resp.user, resp.user.displayName, resp.user.email, hist);
          } else {
            resp.user.getIdToken()
              .then( resp_token => {
                dispatch({type: TSOCIAL_LOGGED_IN});
                dispatch(getUsernameAndNavTo(resp_token, hist));
              })
              .catch(err => dispatch({
                type: TSOCIAL_NOT_LOGGED_IN,
                errMsg: `cannot get bearer token: ${err}`,
              }));
          }
        })
        .catch(error => {
          // NOTE not worth time now to finish this (fb login after google login)
          // if account is already linked with Google account,
          // send message, cannot also link with another social account, for now...
          if (!_.isEmpty(error.credential)) {
            const islinkTwoSocialAccountsErrCode = (error.code === "auth/account-exists-with-different-credential");
            // const isSignInAttemptWFb = (error.credential.signInMethod === "facebook.com");
            if (islinkTwoSocialAccountsErrCode) {
              linkFbAccountToGoogle(dispatch, error);
            } else {
              dispatch({
                type: TSOCIAL_NOT_LOGGED_IN,
                errMsg: error.message,
              });
            }
          } else {
            dispatch({
              type: TSOCIAL_NOT_LOGGED_IN,
              errMsg: error.message,
            });
          }
        });
    }
  };
};

// // NOTE not worth time now to finish this (fb login after google login)
// // just throw error that cannot link to both accounts, for now
const linkFbAccountToGoogle = (dispatch, err) => {
  firebase.auth().fetchSignInMethodsForEmail(err.email)
    .then(providers => {
      if (providers.includes("google.com")) {
        // console.log('we in this bitch.');
        dispatch({
          type: TSOCIAL_NOT_LOGGED_IN,
          errMsg: "This account was already linked to Google! Try again connecting with Google this time :)",
        });
      } else {
        // NOTE to my knowledge, this error should NOT occur? but not 100% positive...
        dispatch({
          type: TSOCIAL_NOT_LOGGED_IN,
          errMsg: `Could not link new social account, please try again, or login with using an existing way ${providers}`,
        });
      }
    })
};

async function generate_random_uname() {
    const resp = await axios.get(URANDOM_USER);
    if (!_.isEmpty(resp.data)) {
      return resp.data.results[0].login.username;
    }
    return null;
}

const createNewUserFromToken = async (dispatch, user, fullName, email, hist) => {
  // first generate random username
  // TODO QUESTION add API check that username is unique?
  const rand_uname = await generate_random_uname();
  if (rand_uname === null) {
    dispatch({type: TFBASE_USER_NOT_CREATED, errMsg: 'cannot get rand user name'});
  } else {
    user.getIdToken()
      .then( resp_token => {
        axios.get(URANDOM_USER)
          .then(resp => {
            const username = resp.data.results[0].login.username;
            const navTo = () => hist.replace(`/user/${username}`);
            dispatch(createUser({token: resp_token, fullName, username, email}, navTo));
          })
          .catch(err => console.log("could not generate username", err));
      })
      .catch(err => dispatch({
        type: TFBASE_USER_NOT_CREATED,
        errMsg: `cannot get bearer token: ${err}`,
      }));
  }
};



// WEBPACK FOOTER //
// ./src/actions/firebase_actions.js